import { columns } from "../../../../dtos/columns";
import { RespuestaDividendosCuadradosDTO } from "../models/dividendosCuadrados";

interface IProps {
  controlTabla: any;
}

export function useColumnsDividendosCuadrados({ controlTabla }: IProps) {
  const COLUMNS: columns<RespuestaDividendosCuadradosDTO>[] = [
    {
        name: "N° Operación",
        selector: (row: RespuestaDividendosCuadradosDTO) => row.nroOperacion?.toString() ?? "Desconocido",
        sortable: true,
        sortField: "nroOperacion",
        wrap: true,
        export: true,
      },
      {
        name: "RUT cliente",
        selector: (row: RespuestaDividendosCuadradosDTO) => row.rutCliente ?? "Desconocido",
        sortable: true,
        sortField: "rutCliente",
        wrap: true,
        export: true,
      },
      {
        name: "Nombre cliente",
        selector: (row: RespuestaDividendosCuadradosDTO) => row.nombreCliente ?? "Desconocido",
        sortable: true,
        sortField: "nombreCliente",
        wrap: true,
        export: true,
      },
      {
        name: "N° Dividendo",
        selector: (row: RespuestaDividendosCuadradosDTO) => row.nroDividendo?.toString() ?? "Desconocido",
        cell: (row: RespuestaDividendosCuadradosDTO) => row.nroDividendo?.toString() ?? "Desconocido",
        sortable: true,
        sortField: "nroDividendo",
        wrap: true,
        export: true,
      },
  ]

  return { COLUMNS };
}